(() => {
  if (window.jbFormMotionReady) return;
  window.jbFormMotionReady = true;
  const states = new Map();
  const slowMessage = document.querySelector('script[data-jb-slow-message]')?.dataset.jbSlowMessage || '';
  const reset = form => {
    const state = states.get(form);
    if (!state) return;
    clearTimeout(state.delay);
    clearTimeout(state.timeout);
    state.button.textContent = state.label;
    state.button.removeAttribute('aria-disabled');
    state.button.removeAttribute('aria-busy');
    form.classList.remove('jb-form-pending', 'jb-form-waiting');
    state.status.remove();
    states.delete(form);
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = form.querySelector('[data-jb-form-send]');
    if (!button) return;
    if (states.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    queueMicrotask(() => {
      if (event.defaultPrevented || !form.isConnected) return;
      const status = document.createElement('p');
      status.className = 'jb-form-pending-status visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-atomic', 'true');
      button.closest('.jb-request-actions')?.after(status);
      if (!status.isConnected) button.after(status);
      const state = {button, status, label:button.textContent};
      states.set(form, state);
      button.textContent = button.dataset.jbPendingLabel;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      form.classList.add('jb-form-pending');
      status.textContent = button.dataset.jbPendingLabel;
      state.delay = setTimeout(() => form.classList.add('jb-form-waiting'), 600);
      state.timeout = setTimeout(() => {
        clearTimeout(state.delay);
        form.classList.remove('jb-form-waiting');
        state.button.removeAttribute('aria-busy');
        status.classList.remove('visually-hidden');
        status.textContent = slowMessage;
      }, 20000);
    });
  }, true);
  window.addEventListener('pageshow', () => [...states.keys()].forEach(reset));
  document.addEventListener('shopify:section:unload', event => {
    [...states.keys()].filter(form => event.target.contains(form)).forEach(reset);
  });
})();
